/*
 * @Author: your name
 * @Date: 2021-02-05 15:42:42
 * @LastEditTime: 2022-05-30 17:17:08
 * @LastEditors: xinguangding
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/api/procure/project-view/bidding.js
 */
import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 查询品目价格库历史价格
export function getItemCodePricesApi(itemCode, params) {
  return request({
    url: baseUrl + `/workbench/item-prices/items/${itemCode}/prices`,
    method: 'get',
    params
  })
}

// 品目价格库列表
export function getItemPricePageApi(params) {
  return request({
    url: baseUrl + `/workbench/item-prices/page`,
    method: 'get',
    params
  })
}

// 批量导出品目价格信息
export function exportItemPriceApi(data) {
  window.open(addQueryToUrl(`${baseUrl}/workbench/item-prices/export`, data))
}

// 批量导入品目价格信息
export function importItemPriceApi(data) {
  return request(
    {
      url: baseUrl + `/workbench/item-prices/import`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}
